<template>
  <HXContentCard title="Registro Servicios">
    <div class="px-5 py-4">
      <div class="row">
        <!-- Columna para el CardTable -->
        <div class="col-12 col-md-5 col-lg-7">
          <CardTable :data="dataCards" />
        </div>
        <!-- Columna para los botones -->
        <div class="col-12 col-md-5 col-lg-5 d-flex justify-content-end">
          <!-- Primer botón -->
          <div class="w-auto">
            <BtnAddCardTable v-b-modal.modalCrearRuta text="Crear nueva ruta" class="w-auto" />
          </div>
          <!-- Segundo botón con margen izquierdo para separación -->
          <div class="w-auto ml-3">
            <BtnAddCardTable v-b-modal.modalPlantillaRuta text="Crear puntos de entrega" class="w-auto" />
          </div>
          <!-- Tercer botón con margen izquierdo para separación -->
          <div class="w-auto ml-3">
            <BtnAddCardTable @click="localizarVehiculos()" text="Localizar vehiculos" class="w-auto"
              icon="map-location-dot" variant="success" />
          </div>
        </div>
      </div>
    </div>
    <!-- table registro servicios-->
    <div class="px-4 mt-3">
      <table id="datatable_registroServicios"
        class="table table-bordered table-responsive-md table-striped text-center">
        <thead>
          <tr>
            <th>Ruta</th>
            <th>Descripción</th>
            <th>Conductor</th>
            <th>Auxiliar Ruta</th>
            <th>Placa</th>
            <th>Distancia Total</th>
            <th>Tiempo Total</th>
            <th>Fecha y Hora Ruta</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in listaItems" :key="item.id">
            <td>{{ item.nombreRuta }}</td>
            <td>{{ item.descripcionRuta }}</td>
            <td>{{ item.nombres + ' ' + item.apellidos }}</td>
            <td>{{ item.auxiliarRuta}}</td>
            <td>{{ item.placa }}</td>
            <td>{{ item.distanciaTotalRecorrida }}</td>
            <td>{{ item.tiempoTotalRecorrido }}</td>
            <td>{{ item.fechaHoraInicioRuta | timeSince }}</td>
            <td>{{ item.estadoRuta }}</td>
            <td class="d-flex">
              <vs-button success v-b-tooltip="{
                title: 'Añadir puntos de entrega a la ruta',
                placement: 'top',
                customClass: 'font_tooltip',
              }" icon @click="obtenerId(item.id)">
                <i class="fa-solid fa-truck-ramp-box"></i>
              </vs-button>

              <vs-button danger v-b-tooltip="{
                title: `Ver Ruta completa del Vehículo`,
                placement: 'top',
                customClass: 'font_tooltip',
              }" icon @click="$router.push({ name: 'RecorridoVehiculo', params: { id: item.id } })">
                <i class="fas fa-map-marked-alt"></i>
              </vs-button>

              <vs-button info v-b-tooltip="{
                title: 'Ver Puntos de Entrega',
                placement: 'top',
                customClass: 'font_tooltip',
              }" icon @click.prevent="openPuntosEntregaModal(item.id)">
                <i class="fas fa-map-marker-alt"></i>
              </vs-button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Modal para puntos de entrega -->
      <b-modal title="Puntos de Entrega" id="modalPuntosEntrega" size="xl" hide-footer v-if="selectedItem"
        class="modal-xl-custom">
        <exportExcel v-if="listaPuntosEntrega.length > 0" :headers="exportarResultados" :items="listaPuntosEntrega"
          class="d-flex justify-content-end px-5 pt-2" />
        <div class="table-container">
          <table id="datatable_registroPuntosEntrega"
            class="table table-bordered table-responsive-md table-striped text-center">
            <thead>
              <tr>
                <th v-for="header in headerPuntosEntrega" :key="header">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in listaPuntosEntrega" :key="item.id">
                <td v-for="key in puntosEntregaKeys" :key="key">{{ item[key] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
    <!-- modal plantilla ruta -->
    <b-modal title="Nueva Plantilla de Ruta" id="modalPlantillaRuta" size="xl" hide-footer>
      <PlantillaRutaModal />
    </b-modal>
    <!-- modal punto entrega -->
    <b-modal title="CREAR UNA NUEVA RUTA" class="text-uppercase" id="modalCrearRuta" size="lg" hide-footer>
      <CrearRutaModal @ruta-agregada=getData @cerrar-modal="cerrarModal('modalCrearRuta')" />
    </b-modal>
    <b-modal title="Planificar ruta" id="modalPlanificarRuta" size="xl" hide-footer>
      <PlanificadorRutas :rutaIdObtener="rutaId" />
    </b-modal>
  </HXContentCard>
</template>

<script>
import CardTable from "../../../components/cardTable/CardTable.vue";
import BtnAddCardTable from "../../../components/btnCardTable/btnAddCardTable.vue";
import PlantillaRutaModal from "./PlantillaRutaModal.vue";
import CrearRutaModal from "./CrearRutaModal.vue";
import PlanificadorRutas from "./PlanificadorRutas.vue";
import moment from "moment/moment";
import moment_timezone from "moment-timezone";
import "moment/locale/es";
import exportExcel from "../../../components/exportExcel/exportExcel.vue";

moment.locale("es");

export default {
  name: "registroServicios",
  components: {
    CardTable,
    BtnAddCardTable,
    PlantillaRutaModal,
    CrearRutaModal,
    exportExcel,
    PlanificadorRutas
  },
  data() {
    return {
      persona: {},
      dataTableInstance: null,
      listaItems: [],
      listaPuntosEntrega: [],
      //Exportar datos a Excel
      exportarResultados: [
        {
          key: "lugarEntrega",
          header: "Nombre Punto"
        },
        {
          key: "fechaHoraInicio",
          header: "Fecha y hora de inicio"
        },
        {
          key: "fechaHoraEntrega",
          header: "Fecha y Hora de entrega aproximada"
        },
        {
          key: "fechaHoraFin",
          header: "Fecha y Hora de Fin"
        },
        {
          key: "latUbicacionEntrega",
          header: "Latitud de la ubicación de Entrega"
        },
        {
          key: "longUbicacionEntrega",
          header: "Longitud de la Ubicación de Entrega"
        },
        {
          key: "distanciaRecorrida",
          header: "Distancia Recorrida"
        },
        {
          key: "tiempoRecorrido",
          header: "Tiempo Recorrido"
        },
        {
          key: "estadoPuntoEntrega",
          header: "Estado del Punto de Entrega"
        },
        {
          key: "ubicacion",
          header: "Ubicación de la Ruta"
        },
        {
          key: "NumeroDocumentoEntrega",
          header: "Número Documento"
        },
        {
          key: "DescripcionPuntoEntrega",
          header: "Descripción De Entrega"
        },
        {
          key: "NombreCliente",
          header: "Nombre Cliente"
        },
        {
          key: "DireccionPuntoEntrega",
          header: "Dirección Punto Entrega"
        },
        {
          key: "CodigoSN",
          header: "Nit"
        },
        {
          key: "NombrePersonaCliente",
          header: "Persona que Recibió"
        },
        {
          key: "ContactoPersonaCliente",
          header: "Contacto de La persona Que Recibió"
        },
      ],
      //Headers y keys para la tabla
      headerPuntosEntrega: ["Nombre Punto", "Fecha y hora de inicio", "Fecha y Hora de entrega Estimada", "Fecha y Hora Fin", "Latitud de la ubicación de Entrega", "Longitud de la Ubicación de Entrega", "Distancia Recorrida", "Tiempo Recorrido", "Estado del Punto de Entrega", "Ubicación de la Ruta", "Número Documento", "Descripción De Entrega", "Nombre Cliente", "Dirección Punto Entrega", "Nit", "Persona que Recibió", "Contacto de La persona Que Recibió"],
      puntosEntregaKeys: ["lugarEntrega", "fechaHoraInicio", "fechaHoraEntrega", "fechaHoraFin", "latUbicacionEntrega", "longUbicacionEntrega", "distanciaRecorrida", "tiempoRecorrido", "estadoPuntoEntrega", "ubicacion", "numeroDocumentoEntrega", "descripcionPuntoEntrega", "nombreCliente", "direccionPuntoEntrega", "codigoSN", "nombrePersonaCliente", "contactoPersonaCliente"],
      dataCards: [
        {
          title: "Total Puntos de Entrega",
          value: () => this.listaItems.length,
          iconName: "map-marker-alt",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: () => {
            this.dataTableInstance.search("").draw();
          },
          onDeactivate: () => {
            this.dataTableInstance.search("").draw();
          },
        },
      ],
      selectedItem: null, // ID del ítem seleccionado para el modal
      rutaId: null,
    };
  },
  async mounted() {
    this.$isLoading(true);
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.listaItems = [];
    await this.getData();

    if (window.$.fn.DataTable.isDataTable("#datatable_registroServicios")) {
      window.$("#datatable_registroServicios").DataTable().destroy();
    }
    this.dataTableInstance = window
      .$("#datatable_registroServicios")
      .DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
    this.$isLoading(false);
  },
  methods: {
    cerrarModal(modalName) {
      // Oculta el modal y luego refresca la lista
      this.$bvModal.hide(modalName);
    },

    verCoordenadasConductor(item) {
      console.log("ID del punto de entrega:", item);
      this.$router.push({
        name: 'DetallePuntoEntrega',
        params: { id: item.id }
      });
    },

    localizarVehiculos() {
      this.$router.push({
        name: 'LocalizarVehiculos',
      });
    },

    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "EntregasApp/GetPuntosEntregaGeneralesConPersonasByEmpresaId/" + this.persona.empresa.id,
        });
        console.log("ESTE ES EL LISTADO DE LAS RUTAS GENERADAS", res.data)
        if (res.success) {
          this.listaItems = res.data;
        } else {
          this.listaItems = [];
          console.log("No se encontraron puntos de entrega para esta empresa");
        }
      } catch (error) {
        this.listaItems = [];
        console.log("Error al obtener los datos:", error);
      }
    },
    async verDetallesRuta(id) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "EntregasApp/GetDetallesEntregaByRutaId/" + id,
        });
        console.log(res);
        if (res.success && res.data && res.data.length > 0) {
          this.ListarPuntosEntrega = res.data;
          console.log("ListarPuntosEntrega de la ruta:", this.ListarPuntosEntrega);
        } else {
          this.$bvToast.toast('No se encontraron detalles para esta ruta', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.log("Error al obtener los detalles de la ruta:", error);
        this.$bvToast.toast('Error al obtener los detalles de la ruta', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    async openPuntosEntregaModal(id) {
      this.selectedItem = id;
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: `EntregasApp/GetPuntosEntrega/${id}`,
        });

        if (res.success && res.data && res.data.length > 0) {
          // Función para formatear la fecha como "D MMM YYYY hh:mm A"
          const formatDate = (dateStr) => {
            if (!dateStr) return "No hay fecha registrada";

            const date = new Date(dateStr);
            const options = { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true };
            return new Intl.DateTimeFormat("es-ES", options).format(date);
          };

          // Formatear las fechas antes de asignarlas
          this.listaPuntosEntrega = res.data.map(item => ({
            ...item,
            fechaHoraInicio: formatDate(item.fechaHoraInicio),
            fechaHoraFin: formatDate(item.fechaHoraFin),
            fechaHoraEntrega: formatDate(item.fechaHoraEntrega)
          }));

          this.$bvModal.show("modalPuntosEntrega");
        } else {
          this.$bvToast.toast("No se encontraron detalles para esta ruta", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Error al obtener los puntos de entrega:", error);
      }
    },
    async verRutaEnMapa(id) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "EntregasApp/GetDetallesEntregaByRutaId/" + id,
        });
        if (res.success && res.data && res.data.length > 0) {
          this.abrirGoogleMaps(res.data);
        } else {
          this.$bvToast.toast('No se encontraron detalles para esta ruta', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.error("Error al obtener los detalles de la ruta:", error);
        this.$bvToast.toast('Error al obtener los detalles de la ruta', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    async validarYAbrirModal(id) {
      this.$isLoading(true);
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: `EntregasApp/GetPuntosEntrega/${id}`,
        });

        if (res.success && res.data && res.data.length > 0) {
          // La ruta ya tiene puntos de entrega
          this.$bvModal.msgBoxConfirm('Esta ruta ya tiene puntos de entrega asignados. ¿Desea continuar y añadir más puntos?', {
            title: 'Puntos de entrega existentes',
            size: 'md',
            buttonSize: 'xl',
            okVariant: 'success',
            okTitle: 'Continuar',
            cancelTitle: 'Cancelar',
            headerClass: 'mb-4',
            footerClass: 'mt-4',
            centered: true
          })
            .then(value => {
              if (value) {
                this.abrirModalPlanificarRuta(id);
              }
            });
        } else {
          // La ruta no tiene puntos de entrega, abrir el modal directamente
          this.abrirModalPlanificarRuta(id);
        }
      } catch (error) {
        console.error("Error al validar los puntos de entrega:", error);
        this.$bvToast.toast('Error al validar los puntos de entrega', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.$isLoading(false);
      }
    },
    abrirModalPlanificarRuta(id) {
      this.rutaId = id;
      this.$bvModal.show("modalPlanificarRuta");
    },
    async obtenerId(id) {
      console.log('Validando puntos de entrega para la ruta:', id);
      await this.validarYAbrirModal(id);
    },
  },
  filters: {
    formatDate(date) {
      return date ? moment(date).locale("es").format('D MMM YYYY') : "No hay fecha registrada";
    },
    timeSince(dateString, timezone = "America/Bogota") {
      const dateInBogota = moment_timezone.tz(dateString, timezone);
      return dateInBogota.format("D MMM YYYY hh:mm A");
    },
  },
};
</script>

<style>
.modal-content {
  padding: 20px;
}
</style>
<style scoped>
.modal-xl-custom .modal-dialog {
  max-width: 90%;
  /* Ajusta al 90% del ancho de la ventana */
  width: auto;
  /* Deja que el modal se ajuste automáticamente */
}

.table-container {
  max-height: 60vh;
  /* Limita la altura de la tabla */
  overflow-y: auto;
  /* Permite el desplazamiento vertical si la tabla excede el tamaño */
}

#datatable_registroPuntosEntrega th,
#datatable_registroPuntosEntrega td {
  white-space: nowrap;
  /* Evita que el texto se amontone */
  word-wrap: break-word;
  /* Asegura que el texto largo se divida correctamente */
}
</style>